import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { CustomButton } from '../buttons/customButton';
import CopyIcon from '../../assets/icons/copyIcon.svg';
import closableEnqueueSnackbar from '../closableEnqueueSnackbar/closableEnqueueSnackbar';

interface CopyUrlLinkInterface {
  digcode: string;
  closeDialog: () => void;
}

const CopyUrlLink: React.FC<CopyUrlLinkInterface> = (props) => {
  const { t } = useTranslation();
  const [url, setUrl] = useState('');
  const [showUtmFields, setShowUtmFields] = useState(false);
  const [utmParams, setUtmParams] = useState({
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
    utm_term: '',
    utm_content: '',
  });
  const DIG_CODE = props.digcode;

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    let inputUrl = e.target.value.trim();
    if (!inputUrl.startsWith('https://') && inputUrl.length > 0) {
      inputUrl = `https://${inputUrl}`;
    }
    setUrl(inputUrl);
  };

  const handleUtmChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setUtmParams((prev) => ({ ...prev, [name]: value }));
  };

  const buildUrl = () => {
    if (!url) return '';

    const utmQueryString = Object.entries(utmParams)
      .filter(([_, value]) => value)
      .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
      .join('&');

    let baseUrl = url;
    if (utmQueryString) {
      baseUrl += url.includes('?') ? `&${utmQueryString}` : `?${utmQueryString}`;
    }

    const digPrefix = baseUrl.includes('?') || utmQueryString ? '&' : '?';
    return `${baseUrl}${digPrefix}dig=${DIG_CODE}`;
  };

  const handleCopy = () => {
    const finalUrl = buildUrl();
    if (finalUrl) {
      navigator.clipboard.writeText(finalUrl).then(() => {
        closableEnqueueSnackbar(t('URLcopiedToclipboard'), 'success');
      });
    }
  };

  const generatedUrl = buildUrl();

  return (
    <div className="flex w-full flex-col items-center gap-4">
      <div className="flex h-[48px] w-full max-w-[490px] items-center rounded-[8px] border border-[#BDBDBD]">
        <span className="flex h-full w-[82px] items-center justify-center rounded-l-[8px] bg-[#EAEAEA] font-normal text-primary">
          https://
        </span>
        <input
          type="text"
          placeholder="Paste or enter the rest of the URL here"
          value={url.replace('https://', '')}
          onChange={handleUrlChange}
          className="grow p-2 text-primary outline-none"
        />
      </div>

      <div className="flex h-full w-full max-w-[490px] gap-2">
        <div className="flex h-[48px] w-full max-w-[440px] items-center gap-2 rounded-[8px] border border-[#BDBDBD] bg-[#EAEAEA] p-2">
          <div className="fixed flex max-w-[380px]  items-center gap-1 truncate pl-2">
            {generatedUrl ? (
              <>
                <span className="truncate text-primary">
                  {generatedUrl.split('?')[0]}
                </span>
                <span className=" text-[#4C956C]">
                  {generatedUrl.includes('dig=')
                      && generatedUrl.substring(generatedUrl.lastIndexOf('?') > 0 ? generatedUrl.lastIndexOf('?') : generatedUrl.lastIndexOf('&'))}
                </span>
              </>
            ) : (
              <span className="text-gray-400" />
            )}
          </div>
        </div>
        <button onClick={handleCopy} className="flex h-[48px]  w-[48px] items-center justify-center rounded border border-[#EAEAEA] p-2">
          <img src={CopyIcon} alt="Copy Icon" />
        </button>
      </div>

      <div className="relative flex w-full max-w-[490px] justify-center text-gray-500">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-[#BDBDBD]" />
        </div>
        <span className="relative z-10 bg-white px-4 text-primary">{t('add')}</span>
      </div>

      <button
        onClick={() => setShowUtmFields(!showUtmFields)}
        className="flex h-[48px] w-full max-w-[490px] items-center justify-center rounded-[8px] border border-[#BDBDBD] bg-[#FFFFFF] p-2 font-medium text-primary"
      >
        {t('utmTags')}
      </button>

      {showUtmFields
            && ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'].map((utmParam) => (
              <div key={utmParam} className="flex h-[48px] w-full max-w-[490px] items-center rounded-[8px] border border-[#BDBDBD]">
                <input
                  type="text"
                  placeholder={utmParam.replace('utm_', '').replace('_', ' ').toUpperCase()}
                  name={utmParam}
                  value={(utmParams as any)[utmParam]}
                  onChange={handleUtmChange}
                  className="grow p-2 text-primary outline-none"
                />
              </div>
            ))}

      <div className="mt-4 flex h-full w-full justify-end py-2">
        <CustomButton onClick={() => props.closeDialog()} className="h-[41px]" color="primary">
          {t('done')}
        </CustomButton>
      </div>
    </div>
  );
};

export default CopyUrlLink;
